document.addEventListener('DOMContentLoaded', function() {
  var bubble = document.querySelector('.shopify-chatt-bubble');
  var dialog = document.querySelector('.shopify-chatt-dialog');
  if (!bubble || !dialog) return;

  // Evitar apertura automática
  dialog.style.display = 'none';

  // Toggle diálogo al clic
  bubble.addEventListener('click', function(e) {
    if (bubble.classList.contains('is-open')) {
      bubble.classList.remove('is-open');
      dialog.style.display = 'none';
    } else {
      bubble.classList.add('is-open');
      dialog.style.display = 'block';
    }
  });
});
